import { Module } from '@nestjs/common';
import appSettings from 'apps/services/config';
import { TypeOrmModule } from '@nestjs/typeorm';

import { AppController } from './app.controller';
import { AppService } from './app.service';
import { VehicleAssignmentModule } from './vehicle-assignment/vehicle-assignment.module';
import { VehicleAssignment } from './vehicle-assignment/vehicle-assignment.entity';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
    // host: '142.93.219.119',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.transport_db,
      entities: [VehicleAssignment],
      synchronize: false,
      logging: true
  }),
    VehicleAssignmentModule,
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
